const videos = [
  {
    id: 1,
    image: "/assets/images/gallery/eque-logo (410x320).jpg",
    alt: "Royal Suite",
    link: "https://youtu.be/EBT6Qmaotkc?si=AZYmoeAr60tGqnNw",
  },
  {
    id: 2,
    image: "/assets/images/gallery/eque-logo (410x320).jpg",
    alt: "Couple Deluxe",
    link: "https://youtu.be/KxM4DhHf-SA?si=BcPbpj0-NC_sfHzB",
  },
  {
    id: 3,
    image: "/assets/images/gallery/eque-logo (410x320).jpg",
    alt: "Eque-Family Suite",
    link: "https://youtu.be/yQCXkdVGMn8?si=Jt7QS8irU9yXPcPh",
  },
  {
    id: 4,
    image: "/assets/images/gallery/eque-logo (410x320).jpg",
    alt: "Twine Deluxe",
    link: "https://youtu.be/s3PCY1pQzME?si=_HQ5WxMA33VZ4rNQ",
  },
  {
    id: 5,
    image: "/assets/images/gallery/eque-logo (410x320).jpg",
    alt: "Single Deluxe",
    link: "https://youtu.be/dlKOtStezTA?si=23mOR9z8t2-J72Rp",
  },
  {
    id: 6,
    image: "/assets/images/gallery/eque-logo (410x320).jpg",
    alt: "Eque Single Deluxe",
    link: "https://youtu.be/xnqKDf2ZcVg?si=u3dLYcLf_1v4PYfm",
  },
];
export default videos;
